module.exports = __webpack_public_path__ + "static/photo-5-0ab234a1526dd40f56d56e672561d923.jpg";